import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import AwpSpinner from '@components/Common/AwpSpinner';
import { isValueEmpty, truncateString } from '@awp/helpers/utilsReact';
import { Form } from 'react-bootstrap';
import { STATE_STATUS } from '@awp/constants';
import { defaultSelectStyle } from '@awp/styleConstants';

const LoadingIndicator = () => {
  return (
    <div className="legend__loading">
      <AwpSpinner />
    </div>
  );
};

const MultiValueContainer = ({ selectProps, data }) => {
  const label = data.label;
  const allOptions = selectProps.value;
  const index = allOptions.findIndex((selected) => selected.label === label);
  const count = allOptions.length;
  const isLastSelected = index === allOptions.length - 1;

  if (count === 1) {
    return truncateString(data.label, 18);
  } else if (isLastSelected) {
    return `${count} selected`;
  } else {
    return '';
  }
};

const AwpDropdown = ({
  isMulti,
  data,
  selectedValues,
  onChange,
  title,
  placeholder = 'All',
  allowAll = true,
  hideSelectedOptions = false,
  showCountOnly = true,
  formatOptionLabel = {},
}) => {
  const [components, setComponents] = useState({ LoadingIndicator });
  if (data && !isMulti && allowAll && data.options[0]?.label !== 'All') {
    data.options = [{ value: '', label: 'All' }, ...data.options];
  }
  const handleChange = (selected) => {
    if (isMulti) {
      if (showCountOnly) {
        setComponents({
          MultiValueContainer,
          LoadingIndicator,
        });
      } else {
        setComponents({
          LoadingIndicator,
        });
      }
    }

    onChange(selected);
  };

  return (
    <div>
      {!isValueEmpty(title) ? (
        <Form.Label>
          <b>{title}</b>
        </Form.Label>
      ) : null}
      <Select
        options={data?.options ?? []}
        isMulti={isMulti}
        value={selectedValues}
        placeholder={placeholder}
        closeMenuOnSelect={!isMulti}
        hideSelectedOptions={hideSelectedOptions}
        components={components}
        onChange={handleChange}
        styles={defaultSelectStyle}
        isLoading={!data || (data.status !== null && data.status !== STATE_STATUS.SUCCESS)}
        formatOptionLabel={formatOptionLabel}
      />
    </div>
  );
};

AwpDropdown.propTypes = {
  isMulti: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.any, label: PropTypes.string })),
    status: PropTypes.string,
  }).isRequired,
  // selectedValues: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.any, label: PropTypes.string })),
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  allowAll: PropTypes.bool,
};

export default AwpDropdown;
